module.exports = __webpack_public_path__ + "static/img/nagraniaBackground.520d634e.webp";